export default {
  SAVE_SUCCESS: 'design/SAVE_SUCCESS',
  SAVE_FAILED: 'design/SAVE_FAILED',
  CLEAR_DESIGN_DATA: 'design/CLEAR_DESIGN_DATA',
  DUPLICATE_DESIGN: 'design/DUPLICATE_DESIGN',
  SAVE: 'design/SAVE',
  FETCH: 'design/FETCH',
  FETCH_SUCCESS: 'design/FETCH_SUCCESS',
  FETCH_FAILED: 'design/FETCH_FAILED',
  SHARE: 'design/SHARE',
  SHARE_SUCCESS: 'design/SHARE_SUCCESS',
  SHARE_FAILURE: 'design/SHARE_FAILURE',
  SHARE_ERROR: 'design/SHARE_ERROR',
  INVALID_UPLOAD: 'design/INVALID_UPLOAD',
  SET_COMBINE_DESIGNS: 'design/SET_COMBINE_DESIGNS',
  UPDATE_INK_MATCHES: 'design/UPDATE_INK_MATCHES',
  REMOVE_INK_MATCH: 'design/REMOVE_INK_MATCH',
  RESET_INK_MATCHES: 'design/RESET_INK_MATCHES'
};
